import { DisplayValueFormatterProps, TabStyles } from '@tableau/widgets';
import React from 'react';
import {
  cssClass,
  Style,
  vizPortalFontStyle,
} from '../../../data-catalog-shared';

const cssPrefix = 'content-menu-item';
const baseCreateButtonContainer: Style = {
  fontSize: TabStyles.Typography.Sizing.Large,
  fontFamily: vizPortalFontStyle.fontFamily,
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  flexDirection: 'row',
  height: '30px',
  paddingRight: TabStyles.Spacing.DefaultSpace,
  paddingLeft: TabStyles.Spacing.DefaultSpace,
};

const menuItemEnabledContainerCss = cssClass(cssPrefix, {
  ...baseCreateButtonContainer,
  cursor: 'pointer',
  color: TabStyles.Typography.Color.Primary,
  $nest: {
    '&:hover': {
      backgroundColor: TabStyles.Colors.L3,
      color: TabStyles.Typography.Color.PrimaryDark,
    },
  },
});

const menuItemDisabledContainterCss = cssClass(cssPrefix, {
  ...baseCreateButtonContainer,
  color: TabStyles.Typography.Color.Disabled,
});

const menuTitleCss = cssClass(cssPrefix, {
  paddingLeft: TabStyles.Spacing.MediumSpace,
});

const lightFontMenuTitleCss = cssClass(cssPrefix, {
  color: TabStyles.Typography.Color.Disabled,
});
export function generateCreateContentMenuItem(
  documentTypeTitle: string,
  resourceUsageTitle: string,
  iconSvg: JSX.Element,
  testId: string,
  disabled: boolean
) {
  return class CreateContentMenuItem extends React.PureComponent<
    DisplayValueFormatterProps
  > {
    override render() {
      const menuContainerCss = disabled
        ? menuItemDisabledContainterCss
        : menuItemEnabledContainerCss;
      return (
        <div
          data-tb-test-id={'create-' + testId + '-button'}
          className={menuContainerCss}
        >
          {iconSvg}
          <div className={menuTitleCss}>
            <div>
              {documentTypeTitle}
              <span className={lightFontMenuTitleCss}>
                {resourceUsageTitle}
              </span>
            </div>
          </div>
        </div>
      );
    }
  };
}
